import { CatalystInsightCategory, CatalystSubcategories } from '@api';
import { POSTHOG_TRACKING_SOURCES } from '@terminal/services/tracking/posthog/constants';
import { CatalystInsightPill } from '@terminal/widgets/catalyst-insights-drawer/catalyst-insight-pill/CatalystInsightPill';
import { useCatalystDrawer } from '@terminal/widgets/catalyst-insights-drawer/useCatalystDrawer';

import styles from './InsightTypePill.module.scss';
import { constructMetadataSentence } from './utils';

export interface InsightTypePillProps {
  createdAt: string;
  updatedAt?: string;
  subCategory?: CatalystSubcategories;
  category: CatalystInsightCategory;
}

export const InsightTypePill = ({
  createdAt,
  updatedAt,
  subCategory,
  category,
}: InsightTypePillProps) => {
  const { insightId } = useCatalystDrawer();

  if (!insightId) {
    return null;
  }

  return (
    <div className={styles.container}>
      <CatalystInsightPill
        insightId={insightId}
        source={POSTHOG_TRACKING_SOURCES.CATALYST_INSIGHT_DRAWER}
        subCategory={subCategory}
        category={category}
      />
      <p className={styles.metadataText}>
        {constructMetadataSentence({
          createdAt,
          updatedAt,
        })}
      </p>
    </div>
  );
};
